import StoreDashboard from "../components/Home/StoreDashboard";

const HomePage = () => {
    return (
        <StoreDashboard/>
    )
}
export default HomePage